import { defineComponent as Q, useSlots as W, computed as i, useTemplateRef as X, ref as d, watchEffect as Y, onMounted as _, onBeforeUnmount as ee, openBlock as f, createElementBlock as g, Fragment as te, createVNode as k, unref as r, withCtx as h, Transition as I, withDirectives as K, createBlock as oe, withModifiers as O, normalizeClass as x, mergeProps as P, renderSlot as c, normalizeProps as m, guardReactiveProps as v, createElementVNode as ae, toDisplayString as le, createCommentVNode as B, vShow as R, nextTick as S } from "vue";
import { RevBackdrop as se } from "@ds/components/Backdrop";
import { RevButtonIcon as ne } from "@ds/components/ButtonIcon";
import { RevPortal as ie } from "@ds/components/Portal";
import { vFocus as re } from "../../directives/focus.js";
import ue from "../../icons/generated/IconCross.vue2.js";
import { useI18n as de } from "@ds/plugin";
import fe from "../../translations/generic.translations.js";
import { tw as a } from "../../utils/tailwind.js";
import { defaultModalTransitionClasses as ce } from "./ModalBase.constant.js";
import { useModalListener as me, isModalOpened as E, openModal as ve, closeModal as be } from "./ModalBase.helpers.js";
const ye = ["aria-label", "inert"], ge = {
  key: 0,
  class: "text-static-default-hi body-1"
}, Ne = /* @__PURE__ */ Q({
  name: "RevModalBase",
  inheritAttrs: !1,
  __name: "ModalBase",
  props: {
    name: {},
    title: { default: "" },
    closeButtonLabel: { default: () => {
    } },
    hasPadding: { type: Boolean, default: !0 },
    backdropZIndex: { default: "z-10" },
    backdropBackgroundColor: { default: () => {
    } },
    backgroundColor: { default: "mid" },
    transitionClassNames: { default: () => ce },
    hasBodyOverflow: { type: Boolean, default: !0 },
    to: { default: "body" },
    defer: { type: Boolean, default: !1 },
    disableCloseOnBackdropClick: { type: Boolean, default: !1 },
    shouldKeepAlive: { type: Boolean, default: !1 }
  },
  emits: ["open", "close"],
  setup(e, { emit: L }) {
    const b = W(), M = L, V = i(() => [
      b.body && a`fixed bottom-0 left-0 flex max-h-dvh w-full flex-col justify-between`,
      b.body && {
        mid: a`bg-surface-default-mid`,
        low: a`bg-surface-default-low`
      }[e.backgroundColor]
    ]), z = i(
      () => b.body && [
        a`relative mx-24 mt-16`,
        e.title ? [
          a`flex items-center justify-center px-40 pb-20 pt-8 text-center after:border-static-default-low after:absolute after:bottom-0 after:border-b after:content-['']`,
          e.hasPadding ? a`after:inset-x-0` : a`after:-inset-x-24`
        ] : a`h-52`
      ]
    ), j = i(
      () => b.body && [
        a`grow`,
        e.hasBodyOverflow ? a`overflow-auto` : a`overflow-hidden`,
        e.hasPadding && [a`p-24 safari-mobile-26:pb-0`, !e.title && a`pt-0`]
      ]
    ), F = de(), U = e.closeButtonLabel || F(fe.buttonClose), Z = X("close-button"), w = d(), l = d(!1), p = d(!1), y = d(!1), $ = i(
      () => e.shouldKeepAlive ? p.value : l.value
    ), T = i(() => !e.shouldKeepAlive || l.value), q = i(() => e.shouldKeepAlive && !l.value);
    async function G() {
      await S(), await S(), Z.value?.$el.focus();
    }
    Y(async () => {
      l.value && !e.shouldKeepAlive && await G();
    });
    const C = d(), A = (t) => {
      C.value = t?.target, ve(e.name);
    }, s = (t) => {
      be(
        e.name,
        t && "cause" in t ? t : void 0
      ), C.value?.focus(), C.value = void 0;
    };
    function H(t) {
      l.value = t.opened, t.opened && !p.value && (p.value = !0), window.document.body.style.overflow = l.value ? "hidden" : "", l.value ? M("open") : M("close", t?.closingEvent);
    }
    function J(t) {
      if (!l.value) return;
      const { key: o, shiftKey: u, target: N } = t;
      if (o === "Escape") {
        s({ cause: "dismiss" });
        return;
      }
      if (w.value && o === "Tab") {
        const n = w.value.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (n.length < 2) {
          t.preventDefault();
          return;
        }
        const D = n.length - 1;
        u === !1 && N === n[D] ? (t.preventDefault(), n[0].focus()) : u === !0 && N === n[0] && (t.preventDefault(), n[D].focus());
      }
    }
    return me(e.name, H), _(() => {
      E(e.name) && A();
    }), ee(() => {
      E(e.name) && s();
    }), (t, o) => (f(), g(te, null, [
      k(r(ie), {
        defer: e.defer,
        to: e.to
      }, {
        default: h(() => [
          k(I, {
            appear: "",
            "enter-active-class": "motion-safe:transition-opacity motion-safe:duration-300",
            "enter-from-class": "opacity-0",
            "leave-active-class": "motion-safe:transition-opacity motion-safe:duration-200",
            "leave-to-class": "opacity-0"
          }, {
            default: h(() => [
              $.value ? K((f(), oe(r(se), {
                key: 0,
                "background-color": e.backdropBackgroundColor,
                class: x(e.backdropZIndex),
                onClick: o[3] || (o[3] = O(
                  () => y.value ? null : s({
                    cause: "backdropClick",
                    disabled: e.disableCloseOnBackdropClick
                  }),
                  ["self"]
                )),
                onMousedown: o[4] || (o[4] = O((u) => y.value = !1, ["self"]))
              }, {
                default: h(() => [
                  k(I, P({ appear: "" }, e.transitionClassNames), {
                    default: h(() => [
                      $.value ? K((f(), g("div", P({ key: 0 }, t.$attrs, {
                        ref_key: "dialog",
                        ref: w,
                        "aria-label": e.title,
                        "aria-modal": "true",
                        class: V.value,
                        inert: q.value,
                        role: "dialog",
                        tabindex: "0",
                        onKeydown: J,
                        onMousedown: o[1] || (o[1] = (u) => y.value = !0),
                        onMouseup: o[2] || (o[2] = (u) => y.value = !1)
                      }), [
                        c(t.$slots, "default", m(v({ close: s })), () => [
                          ae("div", {
                            class: x(z.value)
                          }, [
                            c(t.$slots, "beforeTitle", m(v({ close: s }))),
                            e.title ? (f(), g("h2", ge, le(e.title), 1)) : B("", !0),
                            c(t.$slots, "afterTitle", m(v({ close: s })), () => [
                              k(r(ne), {
                                ref: "close-button",
                                "alternative-text": r(U),
                                class: "absolute right-0 top-0",
                                icon: r(ue),
                                variant: "ghost",
                                onClick: o[0] || (o[0] = () => s({ cause: "dismiss" }))
                              }, null, 8, ["alternative-text", "icon"])
                            ])
                          ], 2),
                          t.$slots.body ? (f(), g("div", {
                            key: 0,
                            class: x(j.value)
                          }, [
                            c(t.$slots, "body", m(v({ close: s })))
                          ], 2)) : B("", !0)
                        ])
                      ], 16, ye)), [
                        [R, T.value],
                        [r(re), l.value]
                      ]) : B("", !0)
                    ]),
                    _: 3
                  }, 16)
                ]),
                _: 3
              }, 8, ["background-color", "class"])), [
                [R, T.value]
              ]) : B("", !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["defer", "to"]),
      c(t.$slots, "trigger", m(v({ open: A })))
    ], 64));
  }
});
export {
  Ne as default
};
